import { Link } from "@inertiajs/react";
import { Brain } from "lucide-react";
import BizminerLayout from "@/bizminer/layouts/app/BizminerLayout.tsx";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card.tsx";
import { bizminer_app_product_guide_path } from "@/routes";

interface Product {
  slug: string;
  title: string;
  description: string;
}

export default function Index({ products }: { products: Product[] }) {
  return (
    <BizminerLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Product Guide</h1>
          <p className="mt-1 text-muted-foreground">
            Explore our product documentation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {products.map((product) => (
            <Link
              key={product.slug}
              href={bizminer_app_product_guide_path(product.slug, { account_id: undefined })}
            >
              <Card className="h-full transition-colors hover:border-primary/50 hover:shadow-md">
                <CardHeader>
                  <div className="flex items-center gap-3">
                    <div className="flex size-10 items-center justify-center rounded-lg bg-primary/10">
                      <Brain className="size-5 text-primary" />
                    </div>
                    <CardTitle className="text-lg">{product.title}</CardTitle>
                  </div>
                  <CardDescription className="mt-2">
                    {product.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </BizminerLayout>
  );
}
